import { FC } from 'react';
import '../../styles/footer/index.css';

const Footer: FC = () => {

  return <footer>
Portafolio Cristobal Ortega, React 17.0.41(typeScript).
  </footer>
}


export default Footer;